var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Material
import { Box, Stack } from "@mui/material";
import Text from "../../../Atoms/Text";
import TextField from "../../../Atoms/Inputs/TextField";
import ErrorMessage from "../../../Atoms/ErrorMessage";
import withControl from "../../../../hoc/withFormControl";
/**
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
var HookTextField = function (_a) {
    var name = _a.name, _b = _a.showCharChount, showCharChount = _b === void 0 ? false : _b, inputProps = _a.inputProps, _c = _a.showErrors, showErrors = _c === void 0 ? true : _c, helperText = _a.helperText, _d = _a.maxLength, maxLength = _d === void 0 ? 0 : _d, callback = _a.callback, helperNode = _a.helperNode, wrapperSx = _a.wrapperSx, _e = _a.controllerFields, _f = _e.field, ref = _f.ref, value = _f.value, onChange = _f.onChange, fieldProps = __rest(_f, ["ref", "value", "onChange"]), error = _e.fieldState.error, errors = _e.formState.errors, rest = __rest(_a, ["name", "showCharChount", "inputProps", "showErrors", "helperText", "maxLength", "callback", "helperNode", "wrapperSx", "controllerFields"]);
    /**
     * calculate and display current character count
     */
    var charCount = value.length;
    var atCharLimit = charCount >= maxLength;
    var charCountHint = showCharChount && !error && maxLength ? (_jsxs(Text, __assign({ "data-testid": "text-textfield-charcount", weight: 400, className: "textfield-charcount", emphasis: "medium", variant: "body3" }, { children: [charCount, "/", maxLength, " Characters"] }))) : null;
    /**
     * trigger side-effect if needed
     */
    var handleChange = function (e) {
        if (callback) {
            callback(e);
        }
        onChange(e);
    };
    return (_jsxs(Box, __assign({ sx: wrapperSx }, { children: [_jsx("div", __assign({ className: "textfield-wrapper" }, { children: _jsx(TextField, __assign({}, fieldProps, { inputProps: inputProps, value: value, error: !!error || (showCharChount && atCharLimit), helperText: errors[name] ? undefined : helperText, onChange: handleChange }, rest, { inputRef: ref })) })), (charCountHint || helperNode) && (_jsxs(Stack, __assign({ direction: "row", mt: 3, ml: 1, className: "textfield-subtext" }, { children: [charCountHint, helperNode] }))), showErrors && _jsx(ErrorMessage, { errors: errors, name: name })] })));
};
export { HookTextField }; // for react-docgen-typescript
export default withControl(HookTextField, "");
